import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import MiniLoader from 'components/MiniLoader';
import StockAvatar from 'components/StockAvatar';
import { Trash } from 'theme/icon';
import * as actions from 'redux/actions/stockAlertActions';
import { confirmDelete } from 'utils/confirmDialog';
import 'assets/css/alerts.css';

function formatPrice(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) {
        return '—';
    }
    return n.toFixed(2);
}

const Table = (props) => {
    useEffect(() => {
        if (props.user_id) {
            props.loadList({ id: props.user_id }, props.token);
        }
    }, [props.user_id]);

    const onClickDelete = (item) => {
        confirmDelete(I18n.t('delete_confirm_message'), () => {
            props.removeItem({
                id: props.user_id,
                alert_id: item.id,
            }, props.token);
        });
    };

    return (
        <div className="alerts-table-wrapper">
            {props.loading && props.list.length === 0 ? (
                <div className="alerts-loading">
                    <MiniLoader />
                </div>
            ) : props.list.length === 0 ? (
                <p className="alerts-empty">
                    <Translate value="alerts_empty" />
                </p>
            ) : (
                <table className="table table-hover alerts-table">
                    <thead>
                        <tr>
                            <th align="left"><Translate value="alerts_symbol" /></th>
                            <th><Translate value="alerts_operator" /></th>
                            <th className="text-end"><Translate value="alerts_target_price" /></th>
                            <th className="text-end"><Translate value="alerts_last_price" /></th>
                            <th><Translate value="alerts_status" /></th>
                            <th className="text-center">A</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <div className="alerts-symbol-cell">
                                        <StockAvatar item={item} symbol={item.symbol} className="avatar-sm" />
                                        <div className="alerts-symbol-meta">
                                            <RouterLink to={`/stock/${item.symbol}`} className="alerts-symbol-link">
                                                {item.symbol.toUpperCase()}
                                            </RouterLink>
                                            {item.name && (
                                                <span className="alerts-symbol-name">{item.name}</span>
                                            )}
                                        </div>
                                    </div>
                                </td>
                                <td className="alerts-operator">{item.operator}</td>
                                <td className="text-end">${formatPrice(item.target_price)}</td>
                                <td className="text-end">${formatPrice(item.ask)}</td>
                                <td>
                                    <span className={`alerts-status alerts-status--${(item.status || 'ACTIVE').toLowerCase()}`}>
                                        {item.status || 'ACTIVE'}
                                    </span>
                                </td>
                                <td className="text-center">
                                    <button
                                        type="button"
                                        className="watchlist-action-icon"
                                        onClick={() => onClickDelete(item)}
                                        aria-label="Delete alert"
                                    >
                                        <Trash />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

Table.propTypes = {
    list: PropTypes.array.isRequired,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.stockAlert.list,
        loading: reducer.stockAlert.loading,
        error: reducer.stockAlert.error,
    };
}

const mapDispatchToProps = (dispatch) => ({
    loadList: (params, token) => dispatch(actions.loadList({ params, token })),
    removeItem: (params, token) => dispatch(actions.removeItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Table);
